import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DialogMessageComponent } from '@fantaz/shared/ui/dialog-message';
import { tap } from 'rxjs';

import * as DialogMessageActions from './dialog-message.actions';
import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ModalAlertComponent } from '@fantaz/shared/ui/modal-alert';

@Injectable()
export class CoreDialogMessageEffects {
  showDialogMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DialogMessageActions.showDialogMessage),
        tap(({ message, actions, disableClose = false, image }) => {
          this.dialog.open(DialogMessageComponent, {
            disableClose,
            data: {
              image,
              message,
              actions,
            },
          });
        }),
      ),
    { dispatch: false },
  );

  /**
   * Open global error dialog
   * HACK: This is a temporary solution to show global error dialog
   */
  showDialog$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(DialogMessageActions.showDialog),
        tap(({ modalType, payload }) => {
          this.dialog.open(ModalAlertComponent, {
            disableClose: true,
            data: {
              ...payload,
              modalType,
            },
          });
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private readonly actions$: Actions,
    private readonly dialog: MatDialog,
  ) {}
}
